module.exports = __webpack_public_path__ + "static/img/product-bg-2.642f0a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-bg-2.png
// module id = rH16
// module chunks = 0